import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VidalyticsLoaderService {
  private renderer: Renderer2;

  constructor(@Inject(DOCUMENT) private document: Document, rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  loadVidalytics(opts: VidalyticsOptions): void {
    const {
      vidalyticsEmbedId,
      buttonId,
      hideClass = 'main__nextPageHidden',
      showClass = 'main__nextPageShown',
      localStorageKey = 'vslVisited',
      mobileTiming,
      desktopTiming
    } = opts;

    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function (v, i, d, a, l, y, t, c, s) {
        y = '_' + d.toLowerCase();
        c = d + 'L';
        if (!v[d]) { v[d] = {}; }
        if (!v[c]) { v[c] = {}; }
        if (!v[y]) { v[y] = {}; }
        var vl = 'Loader',
            vli = v[y][vl],
            vsl = v[c][vl + 'Script'],
            vlf = v[c][vl + 'Loaded'],
            ve = 'Embed';

        if (!vsl) {
          vsl = function(u, cb) {
            if (t) { cb(); return; }
            s = i.createElement("script");
            s.type = "text/javascript";
            s.async = 1;
            s.src = u;
            if (s.readyState) {
              s.onreadystatechange = function() {
                if (s.readyState === "loaded" || s.readyState === "complete") {
                  s.onreadystatechange = null;
                  vlf = 1;
                  cb();
                }
              };
            } else {
              s.onload = function() {
                vlf = 1;
                cb();
              };
            }
            i.getElementsByTagName("head")[0].appendChild(s);
          };
        }

        vsl(l + 'loader.min.js', function() {
          if (!vli) {
            var vlc = v[c][vl];
            vli = new vlc();
          }

          vli.loadScript(l + 'player.min.js', function() {
            var vec = v[d][ve];
            t = new vec();
            t.run(a);

            (function(v,a,p,i){
              v.getVidalyticsPlayer = function(n){
                v[a]=v[a]||{},v[a][p]=v[a][p]||{};
                let d=v[a][p][n]=v[a][p][n]||{};
                return new Promise((resolve)=>{
                  if(d[i])return void resolve(d[i]);
                  let t;
                  Object.defineProperty(d,i,{get:()=>t,set(i){t=i,resolve(i)}});
                });
              }
            })(window,'_vidalytics','embeds','player');

            const EMBED_ID = '${vidalyticsEmbedId}';
            const BUTTON_ID = '${buttonId}';
            const LOCAL_KEY = '${localStorageKey}';
            const SHOW_CLS = '${showClass}';
            const HIDE_CLS = '${hideClass}';

            const isMobile = /Mobi|Android/i.test(navigator.userAgent);
            const triggerTime = isMobile ? ${mobileTiming} : ${desktopTiming};

            getVidalyticsPlayer(EMBED_ID).then(function(player) {
              if (!player) return;

              try { localStorage.setItem(LOCAL_KEY, 'true'); } catch(e) {}

              var button = document.getElementById(BUTTON_ID);

              if (localStorage.getItem(LOCAL_KEY) === 'true' &&
                  window.performance && window.performance.navigation &&
                  window.performance.navigation.type === 1) {
                if (button) {
                  button.classList.remove(HIDE_CLS);
                  button.classList.add(SHOW_CLS);
                }
                return;
              }

              var isTimeTrapTriggered = false;
              player.on('timeupdate', function() {
                var currentTime = Math.floor(player.currentTime());
                if (!isTimeTrapTriggered && currentTime >= triggerTime) {
                  isTimeTrapTriggered = true;
                  var btn = document.getElementById(BUTTON_ID);
                  if (btn) {
                    btn.classList.remove(HIDE_CLS);
                    btn.classList.add(SHOW_CLS);
                  }
                }
              });
            });
          });
        });
    })(window, document, 'Vidalytics', '${vidalyticsEmbedId}', 'https://fast.vidalytics.com/embeds/DXNWe2Do/${vidalyticsEmbedId}/');
    `;

    this.renderer.appendChild(this.document.body, script);
  }
}

export interface VidalyticsOptions {
    vidalyticsEmbedId: string;
    buttonId: string;
    hideClass?: string;
    showClass?: string;
    localStorageKey?: string;
    mobileTiming: number;
    desktopTiming: number;
  }